import React from "react";

import DecisionAnalysisPanel from
  "../../../components/risk_financing/decision/DecisionAnalysisPanel";

import useRiskFinancingContext from
  "../context/useRiskFinancingContext";


export default function RiskFinancingDecisionAnalysisTab({
  settings,
}) {

  const {
    decisionAnalysis,
  } = useRiskFinancingContext();

  const {
    analysis,
    state,
  } = decisionAnalysis;

  return (
    <DecisionAnalysisPanel
        data={analysis}
        loading={state.loading}
        error={state.error}
        settings={settings}
    />
  );
}